export const SectionHeader = (props) => {
  const { title } = props

  return <h2 className="text-2xl font-bold uppercase pb-4 pt-8">{title}</h2>
}